// Е10 — презентационен изглед на С3 (пълна справка по ползвател), с данни
// подадени като prop. Без requester/PDF — ползва се на публичната страница.
//
// Ъ15 (10.10.2026) — три разлики от вътрешната С3, поискани САМО за линка:
// колоната „Негодна" не се показва, ДЗ е оцветено по знака и заглавието е
// „Доброволни замени (ДЗ)". Справката зад вход и нейният PDF остават същите.

// Ъ15: ДЗ над нула — зелено, под нула (със знак „-") — червено, нула — без цвят.
// Прагът е половин стотинка, за да не оцвети „0.00", получено от закръгляне.
const цветДЗ = (v) => (v > 0.005 ? 'text-success' : v < -0.005 ? 'text-danger' : '');

export const S3View = ({data}) => {
    if (!data) return null;
    const c = data.company;
    const s = data.settlement;
    const d = data.data;

    return (
        <div className="mt-2">
            <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-2">
                <div>
                    <div className="text-muted">{data.date} | ЕКАТТЕ: {s.ekatte} | {s.settlement}, община {s.municipality}</div>
                    <div className="text-muted">Стопанска {data.year} година</div>
                    <div className="fw-bold mt-2">{c.company_name}, Булстат: {c.bullstat}</div>
                </div>
                <div className="text-end">
                    <div className="card px-3 py-1 mb-1 text-center"
                         style={{borderColor: "var(--app-gold)", backgroundColor: "var(--app-surface-3)"}}>
                        <span className="fw-bold" style={{fontSize: "1.1em", color: "var(--app-gold)"}}>
                            Правно: {d.pravno.toFixed(2)}
                        </span>
                    </div>
                    <div className="card px-3 py-1 text-center"
                         style={{borderColor: "var(--app-gold)", backgroundColor: "var(--app-surface-3)"}}>
                        <span className="fw-bold" style={{fontSize: "1.1em"}}>
                            Изчертано: {d.drawings_sum.toFixed(2)}
                        </span>
                    </div>
                </div>
            </div>

            <div className="table-responsive">
                <table className="table table-sm table-bordered mb-3" style={{maxWidth: "700px"}}>
                    <thead className="tableHead">
                    <tr>
                        <th className="text-end">Деклар.</th>
                        <th className="text-end">Годна</th>
                        <th className="text-end">БП</th>
                        <th className="text-end">Пътища</th>
                        <th className="text-end">ДЗ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="text-end">{d.declared_land.toFixed(2)}</td>
                        <td className="text-end">{d.suitable_land.toFixed(2)}</td>
                        <td className="text-end">{d.white_spots.toFixed(2)}</td>
                        <td className="text-end">{d.roads.toFixed(2)}</td>
                        <td className={`text-end ${цветДЗ(d.deals_sum)}`}>
                            {/* „-0.00" от закръгляне се показва като „0.00". */}
                            {(Math.abs(d.deals_sum) < 0.005 ? 0 : d.deals_sum).toFixed(2)}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            {data.deals.length > 0 && (
                <div className="table-responsive">
                    <h6 className="fw-bold">Доброволни замени (ДЗ)</h6>
                    <table className="table table-sm table-bordered">
                        <thead className="tableHead">
                        <tr>
                            <th>Ползвател</th>
                            <th>За село</th>
                            <th className="text-end">Сума (дка)</th>
                            <th>Посока</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.deals.map((deal, i) => (
                            <tr key={i}>
                                <td>{deal.company_other}</td>
                                <td>{deal.settlement_other}</td>
                                <td className="text-end">
                                    {Math.abs(deal.amount).toFixed(2)}
                                    {deal.count > 1 && <span className="text-muted"> ({deal.count})</span>}
                                </td>
                                <td>{deal.bullstat_receiving === c.bullstat ? "получава" : "дава"}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}

            {data.drawings.length > 0 && (
                <div className="table-responsive">
                    <h6 className="fw-bold mt-3">Изчертани площи</h6>
                    <table className="table table-sm table-bordered">
                        <thead className="tableHead">
                        <tr>
                            <th>№</th>
                            <th>Масив</th>
                            <th>МПО</th>
                            <th className="text-end">Площ (дка)</th>
                            <th>Култура</th>
                            {/* Ш3: забележката се вижда и през публичния линк —
                                изрично поискано. Тя стига до ползвателя, тоест
                                не е място за вътрешни бележки. */}
                            <th>Забележка</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.drawings.map((dr, i) => (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{dr.massif_number}</td>
                                <td>{dr.mpo_number}</td>
                                <td className="text-end">{dr.area.toFixed(2)}</td>
                                <td>{dr.crop}</td>
                                <td>{dr.note}</td>
                            </tr>
                        ))}
                        </tbody>
                        <tfoot>
                        <tr className="fw-bold">
                            <td colSpan={3}>ОБЩО</td>
                            <td className="text-end">{d.drawings_sum.toFixed(2)}</td>
                            <td></td>
                            <td></td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            )}
        </div>
    );
};
